import { render, staticRenderFns } from "./Chain.vue?vue&type=template&id=4b925ecb&scoped=true&lang=pug&"
import script from "./Chain.vue?vue&type=script&lang=js&"
export * from "./Chain.vue?vue&type=script&lang=js&"
import style0 from "./Chain.vue?vue&type=style&index=0&id=4b925ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b925ecb",
  null
  
)

export default component.exports